import React, {useState,useEffect}   from 'react';
import axios from 'axios';
import swal from "sweetalert";
import CryptoJS from 'crypto-js';

const Footer = () => {

    const handleChange = (e) => {
          const { name, value } = e.target;
          setValues({
              ...values,
              [name]: value
          });
      };
    
      const saltedSha256 = (data, salt) => {
        return CryptoJS.SHA256(data + salt).toString();
      };

        const [values, setValues] = useState({
            name: "",
            email: "",
            number: "",
            pesan:""
      })
    
      const postSend = (e) =>{
          e.preventDefault();
          let data = new FormData();
          let form = {
              name : values.name,
              email : values.email,
              number : values.number,
              pesan : values.pesan,
          }
          let key = saltedSha256(Math.floor(Date.now() / 1000)+' - '+saltedSha256(JSON.stringify(form),'lkdsjflekjelkrerAI'),'lksjelejrelrje');
          data.append('name',values.name);
          data.append('email',values.email);
          data.append('number',values.number);
          data.append('pesan',values.pesan);
          data.append('key',key);
          
          document.querySelector(".not_loading").setAttribute('style','display:none');
          document.querySelector(".loading").setAttribute('style','display:block');
    
          axios.post(`${process.env.REACT_APP_API}hubungi-kami`, data)
          .then(response => {
              if(response.data.status)
              {
                  swal("Berhasil", response.data.message, "success").then((value) => {
                      window.location.reload();
                  });
              }else{
                  swal("Maaf", response.data.message, "warning");
                  document.querySelector(".loading").setAttribute('style','display:none');
                  document.querySelector(".not_loading").setAttribute('style','display:block');
              }
          })
          .catch(error => {
              swal("Maaf",error.data.message, "warning");
              document.querySelector(".loading").setAttribute('style','display:none');
              document.querySelector(".not_loading").setAttribute('style','display:block');
          });
      }
    
    return (
      <footer id="footer-section" className="bg-[#F8F9FA] pt-16 md:pt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24">
            <div className="flex flex-col gap-6">
              <h3 className="text-[#101828] font-bold text-2xl md:text-3xl">
                Satu Summarecon Sukses
              </h3>
              <p className="text-[#475467] font-normal text-sm md:text-base leading-relaxed">
                PT Satu Summarecon Sukses (“TRIPLE-S”) selaku pengelola Aplikasi yang bekerja sama dengan pihak-pihak terkait dalam rangka penyelenggaraan Aplikasi
              </p>
              <div className="flex items-center gap-4">
                <a href='https://www.instagram.com/summareconapps' target='_blank' rel='noopener noreferrer'>
                  <img 
                    src={process.env.PUBLIC_URL+"/assets/img/ic_instagram.png"} 
                    alt="Instagram" 
                    className="w-6 md:w-10 object-contain" 
                  />
                </a>
                
                <a href='https://www.tiktok.com/@summareconapps' target='_blank' rel='noopener noreferrer'>
                  <img 
                    src={process.env.PUBLIC_URL+"/assets/img/ic_tiktok.png"} 
                    alt="Tiktok" 
                    className="w-6 md:w-10 object-contain" 
                  />
                </a>
              </div>
              <div className="flex items-start gap-4">
                <img 
                  src="https://summarecon-apps-dev-s3.s3.ap-southeast-3.amazonaws.com/stss/marker-pin-01.png" 
                  alt="Pin Location" 
                  className="w-6 h-6 object-contain mt-1" 
                />
                <p className="text-[#475467] font-normal text-sm md:text-base leading-relaxed">
                  <span className="font-semibold block mb-1">PT SATU SUMMARECON SUKSES</span>
                  Plaza Summarecon, Jalan Boulevard Gading<br />
                  Serpong, Blok M.5 No 3, 15810.
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-6">
              <div>
                <h3 className="text-[#101828] font-bold text-2xl md:text-3xl mb-2">
                  Hubungi Kami
                </h3>
                <p className="text-[#475467] font-normal text-sm md:text-base leading-relaxed">
                  Untuk informasi lebih lanjut, silahkan isi form dibawah ini untuk menghubungi tim kami
                </p>
              </div>
              <form className="flex flex-col gap-5">
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-semibold text-[#344054]">Nama</label>
                  <input 
                    type="text" 
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    placeholder="Masukkan Nama" 
                    required 
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#F36F21] focus:border-transparent transition-all bg-white"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold text-[#344054]">Nomor HP</label>
                    <input 
                      type="text" 
                      name="number"
                      value={values.number}
                      onChange={handleChange}
                      placeholder="Masukkan Nomor HP" 
                      required 
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#F36F21] focus:border-transparent transition-all bg-white"
                    />
                  </div>
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold text-[#344054]">Email</label>
                    <input 
                      type="email" 
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      placeholder="Masukkan Email" 
                      required 
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#F36F21] focus:border-transparent transition-all bg-white"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-semibold text-[#344054]">Pesan</label>
                  <textarea 
                    name="pesan"
                    value={values.pesan}
                    onChange={handleChange}
                    placeholder="Masukkan Pesan" 
                    rows="4" 
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#F36F21] focus:border-transparent transition-all bg-white resize-y"
                  ></textarea>
                </div>
                <div className="flex justify-end mt-2">
                  <button 
                    onClick={(e) => postSend(e)}  
                    type="button"
                    className="w-full md:w-auto bg-[#F36F21] hover:bg-[#e0621a] text-white px-10 py-3 rounded-lg font-semibold text-sm transition-colors shadow-sm flex justify-center items-center gap-2"
                  >
                    {/* Pastikan state loading kamu terhubung di sini */}
                    <div className="loading hidden">
                      <span className="spinner-grow spinner-grow-sm inline-block w-4 h-4 rounded-full bg-white animate-pulse"></span> Loading
                    </div>
                    <div className="not_loading block">
                      Kirim
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="bg-[#F36F21] relative overflow-hidden py-4 px-4 sm:px-6 lg:px-8">
          {/* Dekorasi opsional jika ada gambar pattern lingkaran seperti di desain */}
          <div className="absolute right-0 top-0 bottom-0 opacity-20 pointer-events-none w-1/2 md:w-1/4">
            <img 
              src={process.env.REACT_APP_S3+"circle_product.png"} 
              alt="decoration" 
              className="w-full h-full object-cover object-right"
            />
          </div>
          
          <div className="max-w-7xl mx-auto relative z-10 text-white text-xs md:text-sm font-medium text-center md:text-left">
            © Copyright 2026. All rights reserved.
          </div>
        </div>
      </footer>
    )
  }

export default Footer;